// extracted by mini-css-extract-plugin
export default {"root":"lV22Og","imageWrapper":"MDU1wJ","image":"v2pW7f","title":"ZO5vb7","aside":"on0YWM","imagePreloader":"kAHSqO","itemsWrapper":"W8ZYPh","item":"O1pAEi"};